import { useMemo } from 'react';

export function useUniqueFilters(
  data,
  pickField,
  getText = (field) => field && field.name,
  deps = []
) {
  return useMemo(() => {
    const map = new Map();

    data.forEach((item) => {
      const field = pickField(item);
      if (field && !map.has(field.id)) {
        map.set(field.id, { text: getText(field), value: field.id });
      }
    });

    return Array.from(map.values());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, pickField, getText, ...deps]);
}
